import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonGroup, ButtonToolbar, Row, Col } from 'react-bootstrap';
import { BootstrapTable, SearchField, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import notificationPopUp from '../../../../NotificationPopUp';

import commonFunctions from '../../../../commonFunctions';
import * as consts from '../../../../constants';

import ActiveEditor from '../../../common/checkBox/ActiveEditor';
import AirBnbDateTimePicker from '../../../common/airBnbDatepicker/AirBnbDateTimePicker';
import CheckboxInput from '../../../common/checkBox/CheckboxInput';
import ConfirmationModal from '../../../common/ConfirmationModal';
import SelectInput from '../../../common/SelectInput';
import TextInput from '../../../common/TextInput';
import TooltipFormatter from '../../../common/TooltipFormatter';
import WarrantyAllowanceEditor from './WarrantyAllowanceEditor';
import WarrantyCoverageEditor from './WarrantyCoverageEditor';

import * as authenticationActions from '../../../../actions/authenticationActions';
import * as commonActions from '../../../../actions/commonActions';
import * as tariffActions from '../../../../actions/tariffActions';

const createActiveEditor = (onUpdate, props) => (<ActiveEditor onUpdate={onUpdate} {...props} />);
const warrantyAllowanceEditor = (onUpdate, props) => (<WarrantyAllowanceEditor onUpdate={onUpdate} {...props} />);
const warrantyCoverageEditor = (onUpdate, props) => (<WarrantyCoverageEditor onUpdate={onUpdate} {...props} />);
const createCustomSearchField = (props) => { return (<SearchField className='form-control' defaultValue='' placeholder='Filtra' />); };


class TariffPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            ageLimts: commonFunctions.ageLimtsForCombo(),
            commonState: this.props.commonState,
            authenticationState: this.props.authenticationState,
            tariff: props.tariff,
            gruppi: [],
            clonePianoMutualisticoModal: {
                show: false
            }
        };

        if (!authenticationActions.verifyAuthentication(this.state.authenticationState, this.props.history)) {
            return;
        }

        this.clonePianoMutualistico = this.clonePianoMutualistico.bind(this);
        this.gridActive = this.gridActive.bind(this);
        this.gridPayProselitismo = this.gridPayProselitismo.bind(this);
        this.gridAfterSaveCell = this.gridAfterSaveCell.bind(this);
        this.gridWarrantyCoverageCap = this.gridWarrantyCoverageCap.bind(this);
        this.gridWarrantyAnnualNetValue = this.gridWarrantyAnnualNetValue.bind(this);
        this.gridWarrantyAllowance = this.gridWarrantyAllowance.bind(this);
        this.saveTariff = this.saveTariff.bind(this);
        this.showHideClonePianoMutualisticoModal = this.showHideClonePianoMutualisticoModal.bind(this);
        this.tooltipFormatter = this.tooltipFormatter.bind(this);
        this.updateTariffState = this.updateTariffState.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.commonState !== prevState.commonState || nextProps.authenticationState !== prevState.authenticationState)
            return Object.assign({}, prevState, { authenticationState: nextProps.authenticationState, commonState: nextProps.commonState });
        return null;
    }

    componentDidMount() {
        this.props.actions.loadAllTariffGroups().then((res) => {
            const gruppi = res.items.map((value) => { return { value: value.id, text: value.name }; });
            this.setState(Object.assign({}, this.state, { gruppi }));
        }).catch(error => {
            notificationPopUp.error('Problemi nel caricamento dei Gruppi dei Piani Mutualistici');
        });
        this.props.actions.loadTariff(this.state.tariff.id).then((tariff) => {
            this.setState(Object.assign({}, this.state, { tariff }));
        }).catch(error => {
            notificationPopUp.error(error);
        });
        if (!this.state.commonState.configuration || this.state.commonState.configuration.cities === null || this.state.commonState.configuration.cities.length === 0) {
            this.props.commonActions.loadConfiguration().then(() => {
            }).catch(error => {
                notificationPopUp.error('Problemi nel caricamento della configurazione base');
            });
        }
    }

    clonePianoMutualistico() {
        this.props.actions.cloneTariff(this.state.tariff.id).then((clonedTariffId) => {
            notificationPopUp.success('Piano Mutualistico Clonato');
            this.showHideClonePianoMutualisticoModal();
            this.props.history.goBack();
        }).catch(error => {
            notificationPopUp.error(error);
        });
    }

    updateTariffState(event) {
        const tariff = Object.assign({}, this.state.tariff);
        tariff[event.target.name] = event.target.value;
        var app = Object.assign({}, this.state, { tariff: tariff });
        this.setState(app);
    }

    saveTariff() {
        if (!_.isNil(this.state.tariff.warranties) && this.state.tariff.warranties.length > 0) {
            const wars = this.state.tariff.warranties.filter(x => x.isActive === 'true' || x.isActive === true);
            if (wars.length === 0) {
                notificationPopUp.warning('Attenzione selezionare almeno una Prestazione');
                return;
            }

            for (var i = 0; i < wars.length; i++) {
                if (_.toNumber(wars[i].warrantyCoverageCapId) < 0) {
                    notificationPopUp.warning('Attenzione selezionare il Massimale della prestazione: ' + wars[i].warrantyName);
                    return;
                }
            }

        } else {
            notificationPopUp.warning('Attenzione per poter salvare il Piano Mutualistico ci devono essere delle Prestazioni');
            return;
        }

        if (_.isNil(this.state.tariff.tariffGroupId) || _.toNumber(this.state.tariff.tariffGroupId) < 0) {
            notificationPopUp.warning('Attenzione assegnare un gruppo al Piano Mutualistico');
            return;
        }

        this.props.actions.saveTariff(this.state.tariff).then((newTariff) => {
            this.setState(Object.assign({}, this.state, { tariff: newTariff }));
            notificationPopUp.success('Piano Mutualistico ' + newTariff.code + ' Salvato');
        }).catch(error => {
            notificationPopUp.error(error);
        });
    }

    showHideClonePianoMutualisticoModal() {
        const clonePianoMutualisticoModal = Object.assign({}, this.state.clonePianoMutualisticoModal);
        clonePianoMutualisticoModal.show = !clonePianoMutualisticoModal.show;
        this.setState(Object.assign({}, this.state, { clonePianoMutualisticoModal }));
    }

    gridActive(cell, row) {
        return (
            <center>< CheckboxInput name='isActive' label='' disabled value={cell} /></center>
        );
    }

    gridPayProselitismo(cell, row) {
        return (
            <center>< CheckboxInput name='payProselitismo' label='' disabled value={cell} /></center>
        );
    }

    gridAfterSaveCell(row, cellName, cellValue) {
        const tariff = Object.assign({}, this.state.tariff);
        tariff.warranties.filter(item => item.warrantyId === row.warrantyId)[0][cellName] = cellValue;
        if (cellName === 'warrantyCoverageCapId') {
            tariff.warranties.filter(item => item.warrantyId === row.warrantyId)[0].warrantyAllowanceId = -1;
        }

        var app = Object.assign({}, this.state, { tariff });
        this.setState(app);
    }

    gridWarrantyAnnualNetValue(cell, row) {
        let value = '';
        const app = row.coverageCaps.filter(x => x.id === _.toNumber(cell));
        if (!_.isUndefined(app) && !_.isEmpty(app))
            value = app[0].annualNetValue;
        return (
            <div>{commonFunctions.numberToItalianEuroFormat(value)}</div>
        );
    }

    gridWarrantyCoverageCap(cell, row) {
        let value = '';
        const app = row.coverageCaps.filter(x => x.id === _.toNumber(cell));
        if (!_.isUndefined(app) && !_.isEmpty(app))
            value = app[0].coverageCap;
        return (
            <div>{commonFunctions.numberToItalianEuroFormat(value)}</div>
        );
    }

    gridWarrantyAllowance(cell, row) {
        let value = 0;
        const app = row.coverageCaps.filter(x => x.id === _.toNumber(row.warrantyCoverageCapId));
        if (!_.isUndefined(app) && !_.isEmpty(app)) {
            const appDue = app[0].warrantyAllowances.filter(x => x.id === _.toNumber(cell));
            if (!_.isUndefined(appDue) && !_.isEmpty(appDue))
                value = appDue[0].allowance;
        }
        return (
            <div>{commonFunctions.numberToItalianEuroFormat(value)}</div>
        );
    }

    tooltipFormatter(cell, row) {
        return (
            <TooltipFormatter text={cell} tooltip={cell} placement="top" />
        );
    }

    render() {
        const gridCellEditProp = {
            mode: 'click',
            blurToSave: true,
            afterSaveCell: this.gridAfterSaveCell
        };

        const gridOptions = {
            searchField: createCustomSearchField,
            sizePerPageList: [5, 10, 20, 50]
        };

        const tariffTypes = [{ value: -1, text: '---' }, { value: 1, text: 'Single' }, { value: 2, text: 'Nucleo' }];

        return (
            <div className="container-fluid" >
                <h1>{this.state.tariff.label}</h1>
                <Row>
                    <Col md={12}>
                        <button className='btn btn-primary' onClick={() => this.props.history.goBack()} style={{ marginBottom: 10 }} ><span className='glyphicon glyphicon-arrow-left'></span> Indietro</button>
                        <div className="panel panel-default x-panel">
                            <div className="panel-heading">Piano Mutualistico</div>
                            <div className="panel-body">
                                <Row>
                                    {!_.isEmpty(this.state.tariff.code) ? <Col md={6}>
                                        <TextInput
                                            name='code'
                                            type='text'
                                            label="Codice"
                                            disabled='disabled'
                                            value={this.state.tariff.code}
                                            onChange={this.updateTariffState} />
                                    </Col> : ''}
                                    <Col md={6}>
                                        <TextInput
                                            name="label"
                                            label="Denominazione"
                                            value={this.state.tariff.label}
                                            onChange={this.updateTariffState} />
                                    </Col>
                                    <Col md={6}>
                                        <AirBnbDateTimePicker
                                            disabled={this.state.tariff.lockedOut}
                                            name='startDate'
                                            label="Data Inizio"
                                            value={this.state.tariff.startDate}
                                            onChange={this.updateTariffState} />
                                    </Col>
                                    <Col md={6}>
                                        <AirBnbDateTimePicker
                                            name='expireDate'
                                            label="Data Fine"
                                            value={this.state.tariff.expireDate}
                                            onChange={this.updateTariffState} />
                                    </Col>
                                    <Col md={6}>
                                        <TextInput
                                            disabled='disabled'
                                            name="lockedOut"
                                            label="Modificabile"
                                            value={this.state.tariff.lockedOut ? 'PRESTAZIONI NON PIU\' MODIFICABILI PERCHE\' TARIFFA IN USO ' : 'NON ANCORA IN USO E QUINDI PRESTAZIONI MODIFICABILI'} />
                                    </Col>
                                    <Col md={6}>
                                        <SelectInput
                                            label="Gruppo"
                                            name="tariffGroupId"
                                            defaultOptionText="---"
                                            defaultOptionValue={-1}
                                            value={this.state.tariff.tariffGroupId}
                                            options={this.state.gruppi}
                                            onChange={this.updateTariffState} />
                                    </Col>
                                    <Col md={6}>
                                        <SelectInput
                                            defaultOptionValue={0}
                                            label="Limite d'Età"
                                            name="ageLimit"
                                            onChange={this.updateTariffState}
                                            options={this.state.ageLimts}
                                            value={this.state.tariff.ageLimit} />
                                    </Col>
                                    <Col md={6}>
                                        <CheckboxInput
                                            disabled={this.state.tariff.lockedOut}
                                            label='Piano Flex'
                                            name='isPianoFlex'
                                            onChange={this.updateTariffState}
                                            value={this.state.tariff.isPianoFlex} />
                                    </Col>
                                    <Col md={6}>
                                        <SelectInput
                                            label="Tipo Piano"
                                            name="idTariffType"
                                            onChange={this.updateTariffState}
                                            options={tariffTypes}
                                            value={this.state.tariff.idTariffType ? this.state.tariff.idTariffType + '' : ''} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <TextInput
                                            name="riassicuratoreCode"
                                            label="Riassicuratore Codice"
                                            value={this.state.tariff.riassicuratoreCode}
                                            onChange={this.updateTariffState} />
                                    </Col>
                                    <Col md={6}>
                                        <TextInput
                                            name="riassicuratoreDescription"
                                            label="Riassicuratore Descrizione"
                                            value={this.state.tariff.riassicuratoreDescription}
                                            onChange={this.updateTariffState} />
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col md={12}>
                                        <h3>Prestazioni</h3>
                                        <BootstrapTable data={this.state.tariff.warranties} cellEdit={gridCellEditProp} options={gridOptions} search striped hover pagination>
                                            <TableHeaderColumn dataField='warrantyId' isKey hidden>WarrantyId</TableHeaderColumn>
                                            <TableHeaderColumn dataField='warrantyCompanyName' editable={false} dataSort={true} dataFormat={this.tooltipFormatter}>Nome Compagnia</TableHeaderColumn>
                                            <TableHeaderColumn dataField='label' editable={!this.state.tariff.lockedOut} dataSort={true} dataFormat={this.tooltipFormatter} hidden>Label</TableHeaderColumn>
                                            <TableHeaderColumn dataField='warrantyName' editable={false} dataSort={true} dataFormat={this.tooltipFormatter}>Nome Prestazione</TableHeaderColumn>
                                            <TableHeaderColumn dataField='warrantyCoverageCapId' editable={false} dataSort={true} dataFormat={this.gridWarrantyAnnualNetValue}>Valore Netto</TableHeaderColumn>
                                            <TableHeaderColumn dataField='warrantyCoverageCapId' editable={!this.state.tariff.lockedOut} dataFormat={this.gridWarrantyCoverageCap} customEditor={{ getElement: warrantyCoverageEditor }}>Massimale</TableHeaderColumn>
                                            <TableHeaderColumn dataField='warrantyAllowanceId' editable={!this.state.tariff.lockedOut} dataFormat={this.gridWarrantyAllowance} customEditor={{ getElement: warrantyAllowanceEditor }}>Franchigia</TableHeaderColumn>
                                            <TableHeaderColumn dataField='payProselitismo' dataFormat={this.gridPayProselitismo} editable={!this.state.tariff.lockedOut} dataSort={true} customEditor={{ getElement: createActiveEditor }}>Rimborso</TableHeaderColumn>
                                            <TableHeaderColumn dataField='isActive' dataFormat={this.gridActive} editable={!this.state.tariff.lockedOut} dataSort={true} customEditor={{ getElement: createActiveEditor }}>Selezionata</TableHeaderColumn>
                                        </BootstrapTable>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <Row>
                            <Col md={12} style={{ marginTop: 20 }}>
                                <ButtonToolbar>
                                    <ButtonGroup>
                                        <Button className="btn btn-primary" onClick={this.saveTariff} >
                                            <span className='glyphicon glyphicon-floppy-disk'></span> Salva
                                        </Button>
                                        {authenticationActions.canICloneTariff(this.state.authenticationState) ?
                                            <Button bsStyle='success' onClick={() => this.showHideClonePianoMutualisticoModal()}>
                                                <span className='glyphicon glyphicon-duplicate'></span> Clona il Piano Mutualistico</Button> : ''}
                                    </ButtonGroup>
                                </ButtonToolbar>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <ConfirmationModal
                    title='Clona Piano Mutualistico'
                    message={'Le prestazioni non verrano clonate, ma verranno usate le stesse, Sei sicuro di voler clonare il Piano ?'}
                    show={this.state.clonePianoMutualisticoModal.show}
                    showHide={this.showHideClonePianoMutualisticoModal}
                    action={this.clonePianoMutualistico}
                    commonState={this.state.commonState}
                />
            </div>
        );
    }
}

TariffPage.propTypes = {
    authenticationState: PropTypes.object.isRequired,
    commonState: PropTypes.object.isRequired,
    tariff: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    const tariff = {
        ageLimit: consts.AGE_LIMITS.TYPES.NO_LIMITS,
        code: '',
        id: _.isUndefined(ownProps.match.params.id) ? -1 : ownProps.match.params.id,
        isPianoFlex: false,
        label: '',
        riassicuratoreCode: '',
        riassicuratoreDescription: '',
        warranties: []
    };

    return {
        commonState: state.commonState,
        authenticationState: state.authenticationState,
        tariff: tariff
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(tariffActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch),
        authenticationActions: bindActionCreators(authenticationActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TariffPage);
